import React from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import editIcon from "../../assets/images/user-dashboard/edit-image.svg";
import deleteIcon from "../../assets/images/user-dashboard/trash-bin.svg";
import viewIcon from "../../assets/images/user-dashboard/eye.svg";
import "./ActionMenu.scss";

/**
 * ActionMenu - Global reusable action dropdown component
 * 
 * Usage:
 * <ActionMenu
 *   isOpen={activeDropdown === row.id}
 *   onToggle={() => setActiveDropdown(activeDropdown === row.id ? null : row.id)}
 *   items={[
 *     { label: "Edit", icon: "edit", onClick: () => handleEdit(row.id) },
 *     { label: "Delete", icon: "delete", onClick: () => handleDelete(row.id), danger: true },
 *   ]}
 * />
 */
const ActionMenu = ({ isOpen, onToggle, items, className }) => {
  const getIcon = (iconType) => {
    switch (iconType) {
      case "edit":
        return <img src={editIcon} alt="Edit" width="16" height="16" />;
      case "delete":
        return <img src={deleteIcon} alt="Delete" width="16" height="16" />;
      case "view":
        return <img src={viewIcon} alt="View" width="16" height="16" />;
      case "more":
      default:
        return (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="2" fill="#64748b" />
            <circle cx="10" cy="4" r="2" fill="#64748b" />
            <circle cx="10" cy="16" r="2" fill="#64748b" />
          </svg>
        );
    }
  };

  return (
    <Dropdown isOpen={isOpen} toggle={onToggle} direction="end">
      <DropdownToggle tag="button" className={`action-menu-toggle ${className || ""}`}>
        {getIcon("more")}
      </DropdownToggle>
      <DropdownMenu className="action-menu-dropdown">
        {items.map((item, index) => (
          <button
            key={index}
            onClick={item.onClick}
            className={`action-menu-item ${item.danger ? "action-menu-item--danger" : ""}`}
            type="button"
          >
            {item.icon && <span className="action-menu-item__icon">{getIcon(item.icon)}</span>}
            <span className="action-menu-item__label">{item.label}</span>
          </button>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

ActionMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
      danger: PropTypes.bool,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default ActionMenu;
